import { docReady, getAnimationEndEvent } from '../customLib';

let diwaliState = false;
let inTouch = false;

const mousePos = {};

const getRandomInt = (min, max) => {
	return Math.round(Math.random() * (max - min + 1)) + min;
};

const showGlitter = () => {
	if (diwaliState) {
		if (mousePos.x > 0 && mousePos.y > 0) {
			const range = 15;

			const color = `background: rgb(${getRandomInt(
				0,
				255
			)},${getRandomInt(0, 255)},${getRandomInt(0, 255)});`;

			const sizeInt = getRandomInt(5, 20);
			const size = `height: ${sizeInt}px; width: ${sizeInt}px;`;

			const left = `left:${getRandomInt(
				mousePos.x - range - sizeInt,
				mousePos.x + range
			)}px;`;

			const top = `top:${getRandomInt(
				mousePos.y - range - sizeInt,
				mousePos.y + range
			)}px;`;

			const style = left + top + color + size;
			const $childBall = document.createElement('div');
			$childBall.className = 'diwali-ball';
			$childBall.style = style;
			requestAnimationFrame(() => {
				document.body.appendChild($childBall);
			});
			getAnimationEndEvent &&
				$childBall.addEventListener(getAnimationEndEvent, () => {
					requestAnimationFrame(() => {
						$childBall.parentNode.removeChild($childBall);
					});
				});
		}
		if (inTouch) {
			requestAnimationFrame(showGlitter);
		}
	}
};

const setBallsInPos = e => {
	if (!inTouch) {
		requestAnimationFrame(showGlitter);
		inTouch = true;
	}
	mousePos.x = e.clientX;
	mousePos.y = e.clientY;
};

const setBallsOutOfPos = () => {
	inTouch = false;
	mousePos.x = -1;
	mousePos.y = -1;
};

const setBallsInPosTouch = e => {
	for (let i = 0; i < e.changedTouches.length; i += 1) {
		if (!inTouch) {
			requestAnimationFrame(showGlitter);
			inTouch = true;
		}
		mousePos.x = e.changedTouches[i].clientX;
		mousePos.y = e.changedTouches[i].clientY;
	}
};

const fnToSetInPos = ev => {
	setBallsInPos(ev);
	window.addEventListener('mousemove', setBallsInPos);
};

const fnToSetOutOfPos = e => {
	window.removeEventListener('mousemove', setBallsInPos);
	setBallsOutOfPos(e);
};

export const startDiwaliMouse = () => {
	docReady(() => {
		diwaliState = true;
		window.addEventListener('mousedown', fnToSetInPos);
		window.addEventListener('mouseup', fnToSetOutOfPos);
		window.addEventListener('touchstart', setBallsInPosTouch);
		window.addEventListener('touchmove', setBallsInPosTouch);
		window.addEventListener('touchend', setBallsOutOfPos);

		requestAnimationFrame(showGlitter);
	});
};

export const endDiwaliMouse = () => {
	diwaliState = false;
	inTouch = false;
	window.removeEventListener('mousedown', fnToSetInPos);
	window.removeEventListener('mousemove', setBallsInPos);
	window.removeEventListener('mouseup', fnToSetOutOfPos);
	window.removeEventListener('mousemove', setBallsInPos);
	window.removeEventListener('touchstart', setBallsInPosTouch);
	window.removeEventListener('touchmove', setBallsInPosTouch);
	window.removeEventListener('touchend', setBallsOutOfPos);
};
